import React from 'react'

export default function FaceFeature({ scale, scaleX, outline, verticalOffset }) {
  const transformOrigin = '8.4199 2.7'
  return (
    <g transform={`scale(${scaleX},1) translate(0,${verticalOffset})`}>
      <g transform={`scale(${scale},${scale})`} transform-origin={transformOrigin}>
        <path
          d="M16.4199 0.22998C16.4199 0.22998 13.5899 1.62997 8.41992 1.62997C3.24992 1.62997 0.419922 0.22998 0.419922 0.22998C3.35992 4.38998 6.53992 5.16998 8.41992 5.16998C10.2999 5.16998 13.4799 4.38998 16.4199 0.22998Z"
          fill={outline}
        />
      </g>
    </g>
  )
}
